
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/nakajitsu",
      function () {
        return require("private-next-pages/cases/nakajitsu/index.tsx");
      }
    ]);
  